var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollapseAll(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Kit",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    transform: "translate(-264, -136)",
    fill: "#7A858E",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-expand-all",
    transform: "translate(264, 136)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.2928932,14.2928932 C11.6834175,13.9023689 12.3165825,13.9023689 12.7071068,14.2928932 L15.7071068,17.2928932 C16.0976311,17.6834175 16.0976311,18.3165825 15.7071068,18.7071068 C15.3165825,19.0976311 14.6834175,19.0976311 14.2928932,18.7071068 L12,16.415 L9.70710678,18.7071068 C9.34662282,19.0675907 8.77939176,19.0953203 8.38710056,18.7902954 L8.29289322,18.7071068 C7.90236893,18.3165825 7.90236893,17.6834175 8.29289322,17.2928932 L11.2928932,14.2928932 Z M12.7071068,9.70710678 C12.3165825,10.0976311 11.6834175,10.0976311 11.2928932,9.70710678 L8.29289322,6.70710678 C7.90236893,6.31658249 7.90236893,5.68341751 8.29289322,5.29289322 C8.68341751,4.90236893 9.31658249,4.90236893 9.70710678,5.29289322 L12,7.585 L14.2928932,5.29289322 C14.6533772,4.93240926 15.2206082,4.90467972 15.6128994,5.20970461 L15.7071068,5.29289322 C16.0976311,5.68341751 16.0976311,6.31658249 15.7071068,6.70710678 L12.7071068,9.70710678 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseAll);
export default __webpack_public_path__ + "static/media/collapse-all.146ce02fbbc991971d845372e1c69080.svg";
export { ForwardRef as ReactComponent };